import { render, staticRenderFns } from "./SalesGoods.vue?vue&type=template&id=80d86f1e&"
import script from "./SalesGoods.vue?vue&type=script&lang=js&"
export * from "./SalesGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports